import React, { useState } from 'react';
import { FloatingLabel, Form, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { getLocalStorage } from '../../../common/common';
import '../../../components/centerModal/css/centerModal.scss';
import { getUserDetails, requestRecording } from '../../../Store/actions';
import { changeSettings, otpVerifyForChange } from '../../../Store/actions/profile.action';
import { IoIosArrowDown } from '../../icons';
import isdCodeJson from '../../../common/data/isdcode.json';

const GetRecordingModal = ({ id, show, close }) => {
  //   const [show, setShow] = useState(false);
  const [modalSlide, setModalSlide] = useState(1);
  const [recordingType, setRecordingType] = useState(2);
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [isd, setIsd] = useState('+91');

  const dispatch = useDispatch();
  const userDetails = () => (getLocalStorage('user', false) ? getLocalStorage('user', {}) : {});

  const handleClose = () => {
    close(false);
    setModalSlide(1);
  };
  const otpVerification = () => {
    // console.log('in verify');
    if (isd && mobile) {
      let formdata = new FormData();
      formdata.append('type', 'verify');
      formdata.append('mobile_no', mobile);
      formdata.append('isd', isd);
      formdata.append('otp', otp);
      dispatch(
        otpVerifyForChange(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              //   log('response', res);
              requestGetRecording();
              dispatch(getUserDetails((res) => {}));
            } else if (res.status_code == 203) {
              toast.error(res?.message);
            }
          }
        })
      );
    } else if (email) {
      let formdata = new FormData();
      formdata.append('type', 'emailverify');
      formdata.append('email', email);
      formdata.append('otp', otp);
      dispatch(
        otpVerifyForChange(formdata, (res) => {
          if (res != 'error') {
            if (res.status_code == 200) {
              //   log('response', res);
              requestGetRecording();
            } else if (res.status_code == 203) {
              toast.error(res?.message);
            }
          }
        })
      );
    }
  };
  const userVerification = () => {
    if (isd && mobile) {
      let regexMob = /^\d{10}$/;
      if (!mobile.match(regexMob)) {
        toast.error('Please Enter Mobile No in Correct Format');
      } else {
        let formdata = new FormData();
        formdata.append('type', 'mobile'); //'mobile', 'name', 'email', 'device'
        formdata.append('value', mobile); //for device value will be ""
        formdata.append('isd', isd);
        dispatch(
          changeSettings(formdata, (res) => {
            if (res != 'error') {
              if (res.status_code == 200) {
                // log('response', res);
                setModalSlide(3);
              } else if (res.status_code == 203) {
                toast.error(res?.message);
              }
            }
          })
        );
      }
    } else if (email) {
      let regexEmail =
        /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
      if (!email.match(regexEmail)) {
        toast.error('Please Enter a Valid Email');
      } else {
        let formdata = new FormData();
        formdata.append('type', 'email'); //'mobile', 'name', 'email', 'device'
        formdata.append('value', email); //for device value will be ""
        dispatch(
          changeSettings(formdata, (res) => {
            if (res != 'error') {
              if (res.status_code == 200) {
                // log('response', res);
                setModalSlide(3);
              } else if (res.status_code == 203) {
                toast.error(res?.message);
              }
            }
          })
        );
      }
    } else {
      setModalSlide(3);
      toast.error('Please fill the mandatory field');
    }
  };
  const requestGetRecording = () => {
    dispatch(
      requestRecording(id, recordingType, (res) => {
        if (res != 'error') {
          if (res.status_code == 200) {
            toast.success(
              'We have received your request. We will send you the recording when the session is completed'
            );
          } else if (res.status_code == 203) {
            toast.error('You have already requested. Please wait till the session is completed');
          }
          handleClose();
        }
      })
    );
  };
  const getRecording = () => {
    if (userDetails()?.mobile_primary && userDetails()?.email) {
      requestGetRecording();
    } else {
      setModalSlide(2);
    }
  };
  console.log('show', show);
  console.log('GetRecordingModal');
  return (
    <Modal className="centerModal" show={show} size="md" centered>
      {modalSlide == 1 && (
        <>
          <Modal.Header>
            <Modal.Title className="fs-4 text-black fw-semibold">
              Please choose a way from below
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="w-100 float-start centerModalFrm">
                <div className="row">
                  <Form.Group className="mt-3" controlId="formBasicCheckbox">
                    {['Get Presentation', 'Get Recording', 'Get Both'].map((_r, _idx) => (
                      <Form.Check
                        key={_idx + 1}
                        type="radio"
                        className={`cmnCheckbox mb-3 ps-0`}
                        label={_r}
                        checked={recordingType == _idx + 1}
                        value={_idx + 1}
                        onChange={(e) => setRecordingType(e.target.value)}
                      />
                    ))}
                  </Form.Group>

                  <div className="floatingFrmRow d-flex flex-wrap centerModalBttns">
                    <button
                      className={`col fs-4 fs-4 btn btn-danger`}
                      type="button"
                      onClick={handleClose}
                      aria-label="Cancel"
                    >
                      Cancel
                    </button>
                    <button
                      className={`col fs-4 btn btn-primary gtm_cl_SessionCardV1_getRecording_submit`}
                      type="button"
                      onClick={getRecording}
                      aria-label="Submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </>
      )}
      {modalSlide == 2 && (
        <>
          <Modal.Header>
            <Modal.Title className="fs-4 text-black fw-semibold">
              Please Confirm Your Credentials
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="w-100 float-start centerModalFrm">
                {!('email' in userDetails()) && (
                  <FloatingLabel
                    className="floatingFrmRow mb-3"
                    controlId="floatingInput"
                    label="Enter Your Email *"
                  >
                    <Form.Control
                      className="fs-4 gtm_cl_SessionCardV1_enter_email"
                      // id="gtm_cl_SessionCardV1_enter_email"
                      type="text"
                      placeholder="Enter Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FloatingLabel>
                )}
                {!('mobile_primary' in userDetails()) && (
                  <div className="cmnisdCodeParent  mb-3">
                    <div className="cmnisdCodeSelect">
                      <select
                        onChange={(e) => {
                          setIsd(e.target.value);
                        }}
                        defaultChecked="+91"
                      >
                        {isdCodeJson.map((item, index) => (
                          <option name={item.name} value={item.value}>
                            {item.value}
                          </option>
                        ))}
                      </select>
                      <IoIosArrowDown customClass={'fs-16'} />
                    </div>
                    <FloatingLabel
                      className="floatingFrmRow"
                      controlId="floatingInput"
                      label="Enter Your Mobile No. *"
                    >
                      <Form.Control
                        className={`fs-4 gtm_cl_SessionCardV1_credential_enter_mobile_no`}
                        type="text"
                        placeholder="Enter Your Mobile No."
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                      />
                    </FloatingLabel>
                  </div>
                )}
                <div className="floatingFrmRow d-flex flex-wrap centerModalBttns">
                  <button
                    className={`col fs-4 btn btn-danger gtm_cl_SessionCardV1_credential_cancel`}
                    type="button"
                    onClick={handleClose}
                    aria-label="Cancel"
                  >
                    Cancel
                  </button>
                  <button
                    className={`col fs-4 btn btn-primary gtm_cl_SessionCardV1_credential_submit`}
                    type="button"
                    onClick={userVerification}
                    aria-label="Submit"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </>
      )}
      {modalSlide == 3 && (
        <>
          <Modal.Header>
            <Modal.Title className="fs-4 text-black fw-semibold">
              Please Confirm Your OTP
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="w-100 float-start centerModalFrm">
                <div className="row">
                  <FloatingLabel
                    className="floatingFrmRow mb-3"
                    controlId="floatingInput"
                    label="Enter Your OTP *"
                  >
                    <Form.Control
                      className={`fs-4 gtm_cl_SessionCardV1_enter_otp`}
                      type="text"
                      placeholder="Enter Your OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </FloatingLabel>

                  <div className="floatingFrmRow d-flex flex-wrap centerModalBttns">
                    <button
                      className={`col fs-4 btn btn-danger gtm_cl_SessionCardV1_enter_otp_cancel`}
                      type="button"
                      onClick={handleClose}
                      aria-label="Cancel"
                    >
                      Cancel
                    </button>
                    <button
                      className={`col fs-4 btn btn-primary gtm_cl_SessionCardV1_enter_otp_submit`}
                      type="button"
                      onClick={otpVerification}
                      aria-label="Submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
};

export default GetRecordingModal;
